import { render, staticRenderFns } from "./IndustryNews.vue?vue&type=template&id=1deda58c"
import script from "./IndustryNews.vue?vue&type=script&lang=js"
export * from "./IndustryNews.vue?vue&type=script&lang=js"
import style0 from "./IndustryNews.vue?vue&type=style&index=0&id=1deda58c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports